import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Field, Select, Caption } from "../ui/ds";
import { fmtDur } from "../../lib/format";

// v33 §4.2 — „Nadväzuje na": z čoho robí toto nové kolo pokračovanie.
//
// Ponúka MOJE dobehnuté kolá rovnakého typu aj s výsledkom, nech si človek pri výbere nemusí
// pamätať, ako mu to vtedy šlo — a nemusí kvôli tomu otvárať archív. Keď nie je z čoho vyberať
// (prvá výzva vôbec), pole sa nevykreslí: prázdny select by len mätol.
//
//   kind    "comp" | "challenge" | "habit"  — čo sa ponúka
//   value   id predchodcu (null = samostatné kolo)
export function PrevRoundField({ kind, value, onChange, label = "Nadväzuje na" }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let alive = true;
    api("/api/rounds/candidates?kind=" + kind)
      .then((r) => { if (alive) setItems((r && r.items) || []); })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [kind]);
  if (!items || !items.length) return null;
  const fmtVal = (it) => {
    if (it.value == null) return "bez výsledku";
    if (it.kind === "rate") return it.value + " %";
    return (it.timer ? fmtDur(it.value) : it.value) + " " + (it.unit || "");
  };
  return (
    <Field label={label}>
      <Select value={value == null ? "" : String(value)}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}>
        <option value="">Nie je pokračovanie</option>
        {items.map((it) => (
          <option key={it.id} value={it.id}>{it.name} · {fmtVal(it)}</option>
        ))}
      </Select>
      <Caption variant="note" style={{ marginTop: 6 }}>
        Uvidíš, ako ti to išlo minule, a jedno číslo, ktoré treba prekonať.
      </Caption>
    </Field>
  );
}

// Názov ďalšieho kola: „Plank – august" → „Plank – september". Keď v názve mesiac nie je,
// necháme ho tak — vymyslený prívlastok („2. kolo") by sa do názvu pliesol a človek si ho aj tak
// prepíše. December prechádza na január.
const MONTHS = ["január", "február", "marec", "apríl", "máj", "jún",
                "júl", "august", "september", "október", "november", "december"];

export function nextRoundName(name) {
  const s = (name || "").trim();
  const low = s.toLowerCase();
  for (let i = 0; i < MONTHS.length; i++) {
    if (low.endsWith(MONTHS[i])) {
      return s.slice(0, s.length - MONTHS[i].length) + MONTHS[(i + 1) % 12];
    }
  }
  return s;
}
